import React, { useState, useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';
import './CouponNew.css';
import parse from 'html-react-parser';

// 配合2026更版 
import LogoImg from "./assets/images/2026/logo.svg";
import EventNameImg from "./assets/images/2026/event-name.webp";
import SloganImg from "./assets/images/2026/slogan.svg";
import CongratulationImg from "./assets/images/2026/congratuation.svg";
import LanternA from "./assets/images/2026/lanternA.svg";
import LanternB from "./assets/images/2026/lanternB.svg";

import { CryptoHandler } from './cryptoHandler';

function App() {
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const barcodeRef = useRef();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedRewardId = urlParams.get('RewardId');
  
    if (encryptedRewardId) {
      try {
        const cryptoHandler = new CryptoHandler();
        const decodedRewardId = decodeURIComponent(encryptedRewardId);
        console.log('Decoded RewardId:', decodedRewardId);
  
        const decryptedRewardId = cryptoHandler.decrypt(decodedRewardId);
        console.log('Decrypted RewardId:', decryptedRewardId);
  
        if (decryptedRewardId === '0') {
          // 如果 RewardId 解碼為 0，根據 URL 路徑設定不同的活動資訊
          const pathName = window.location.pathname;
          if (pathName.includes('/MC6')) {
            setSelectedCoupon({ 
              type: 'thanks', 
              award: '銘謝惠顧', 
              code: '', 
              event_name: '和運租車 刮刮樂',
              event_subtitle: '2026迎春好禮抽',
              isMC6: true,
              allPrizesGoneMessage: '哎呀晚來一步，獎項已全數抽完~'
            });
          } else {
            setSelectedCoupon({ 
              type: 'thanks', 
              award: '銘謝惠顧', 
              code: '', 
              event_name: '和運租車 刮刮樂',
              event_subtitle: '2025迎春好禮抽',
              isMC6: false,
              allPrizesGoneMessage: '哎呀晚來一步，獎項已全數抽完~'
            });
          }
        } else {
          fetch(process.env.REACT_APP_API_URL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ RewardId: decryptedRewardId }),
          })
          .then(response => response.json())
          .then(data => {
            if (data && data.data) {
              // 根據 event_id 判斷 award 顯示內容
              const prizeName = (data.data.event_id !== 'MC5' && data.data.event_id !== 'MC6') ? '銘謝惠顧' : data.data.prize_name;
              const isThanks = prizeName === '銘謝惠顧';
  
              // 根據條件設置 code
              const code = (data.data.event_id !== 'MC5' && data.data.event_id !== 'MC6') ? '' : data.data.code;
              const desc = data.data.desc || '請自行截圖，保存圖檔，以免喪失權益！';
  
              setSelectedCoupon({
                type: decryptedRewardId,
                award: prizeName,
                code: code,
                desc: desc,
                showCongrats: (data.data.event_id === 'MC5' || data.data.event_id === 'MC6'),
                event_name: data.data.event_name,
                event_subtitle: data.data.event_subtitle,
                isMC6: data.data.event_id === 'MC6',
                allPrizesGoneMessage: isThanks ? '哎呀晚來一步，獎項已全數抽完~' : undefined
              });
            }
          })          
          .catch(error => {
            console.error('Error fetching prize:', error);
          });
        }
      } catch (error) {
        console.error('Error decoding RewardId:', error);
      }
    } else {
      // URL 中沒有 RewardId，設定預設值，根據 URL 路徑決定年份
      const pathName = window.location.pathname;
      if (pathName.includes('/MC6')) {
        setSelectedCoupon({
          type: 'default',
          award: '',
          code: '',
          event_name: '2026新春抽獎活動',
          event_subtitle: '免費租車券、千元折價券等你拿！',
          isMC6: true
        });
      } else {
        setSelectedCoupon({
          type: 'default',
          award: '',
          code: '',
          event_name: '2025新春抽獎活動',
          event_subtitle: '免費租車券、千元折價券等你抽!',
          isMC6: false
        });
      }
    }
  }, []);
  

  useEffect(() => {
    if (selectedCoupon && barcodeRef.current) {
      // 如果 selectedCoupon.code 為空，不生成條碼
      if (selectedCoupon.code) {
        JsBarcode(barcodeRef.current, selectedCoupon.code, {
          format: "CODE128",
          width: 1.2,
          height: 60,
          displayValue: true,
          fontSize: 12
        });
      }
    }
  }, [selectedCoupon]);

  // 解析獎品名稱，分成兩行顯示
  const parsePrizeName = (award) => {
    if (!award || award === '銘謝惠顧') {
      return { line1: '銘謝惠顧', line2: '' };
    }
    
    // 嘗試根據常見的獎品格式分割
    // 例如：和運租車\nYARIS/VIOS 一日租車券
    if (award.includes('<br/>') || award.includes('<br>')) {
      const parts = award.split(/<br\s*\/?>/i);
      return { line1: parts[0] || '', line2: parts[1] || '' };
    }
    
    // 嘗試根據「和運租車」或「iRent」分割
    if (award.includes('和運租車')) {
      const parts = award.split('和運租車');
      return { line1: '和運租車', line2: parts[1]?.trim() || '' };
    }
    
    if (award.includes('iRent')) {
      const parts = award.split('iRent');
      return { line1: 'iRent', line2: parts[1]?.trim() || '' };
    }
    
    return { line1: award, line2: '' };
  };

  const renderCoupon = (coupon) => {
    const { line1, line2 } = parsePrizeName(coupon.award);
    const isThanks = coupon.award === '銘謝惠顧' || coupon.type === 'thanks';
    
    return (
      <div className="coupon-wrap">
        <div className="coupon">
          <div className="coupon-name">
            <p className="coupon-info1">{line1}</p>
            {line2 && <p className="coupon-info2">{line2}</p>}
          </div>
          {!isThanks && coupon.code && (
            <div className="coupon-codebar-wrap">
              <svg ref={barcodeRef}></svg>
            </div>
          )}
          {isThanks && coupon.allPrizesGoneMessage && (
            <div className="all-prizes-gone-message">
              <p className="all-prizes-gone-text">{coupon.allPrizesGoneMessage}</p>
            </div>
          )}
        </div>
      </div>
    );
  };

  // 根據 isMC6 決定顯示哪個年份的 Footer
  const renderFooter = () => {
    const isMC6 = selectedCoupon?.isMC6;
    
    if (isMC6) {
      // 2026 年版本 Footer
      return (
        <footer className="footer-new">
          <div className="footer-content">
            <h3>注意事項</h3>
            <ol>
              <li>中獎內容不適用春節期間，優惠券使用期限為 2026/3/2 至 2026/6/30</li>
              <li>抽獎後請自行保存中獎圖檔，抽獎人有盡善保管之義務，以免權益喪失</li>
              <li>所有經由本活動領取之獎項，皆須符合其票券規則方得以兌換與使用，用戶不得要求退款、折換現金及遞延使用</li>
              <li>依中華民國稅法規定，獎項金額若達新台幣1,000元(含)以上，將列入個人年度綜合所得稅申報，故中獎者需於交車當天提供身分證影本，且依規定填寫並繳交相關資料。以上稅法規定若中獎者不願意配合，則視為自動棄權，不具中獎資格。其他未盡事宜，悉依中華民國稅法相關規定辦理。</li>
              <li>如有任何疑問，請洽24小時服務專線(02)5589-0808</li>
              <li>和雲行動服務對本內容保有修改、終止、變更方案內容細節之權利</li>
              <li>和運租車之短期租車、專車接送服務由和雲行動服務提供</li>
            </ol>
            
            <h3>和運租車 免費租車券、折價券</h3>
            <ol>
              <li>免費租車券限電話/臨櫃預約</li>
              <li>折價券可於和雲行動服務官網預約，於折價券號欄位輸入兌換序號進行折抵</li>
              <li>免費租車券、折價券僅適用於【一般租車專案】，不得使用於其他專案 (如包月、票根優惠等等)</li>
              <li>本活動發放之獎項內容，無法折抵里程費、etag、罰款、逾時費用等其他費用</li>
              <li>每張券限單次使用，未使用完之餘額不得找零</li>
            </ol>
            
            <h3>和運租車 專車接送折抵券</h3>
            <ol>
              <li>折抵券使用時間：2026/3/2 ~ 2026/6/30，期間於官網預約專車接送服務方可使用 (以預約日期為準)</li>
              <li>此僅限官網會員線上預約使用，且每筆訂單限用一張，無法多張券合併使用</li>
              <li>加價費用 (例如：舉牌、安全座椅、夜間加成…等) 不適用折扣優惠</li>
              <li>報價僅為基本接送費用 (過路費、營業稅)，服務當日超時等費用將另行收費；門票、停車費等將實報實銷，行程結束後將依實際用車狀況收費</li>
              <li>優惠價格/專案價格春節期間、連續或特殊假期不適用 (春節、連續或特殊假期定義請依官網公告為主)</li>
            </ol>
            
            <h3>iRent 汽車折抵券</h3>
            <ol>
              <li>兌換折抵券兌換方式：開啟iRent APP {'>'} 點選左側欄【☰】{'>'} 【優惠管理】{'>'} 【折抵券】{'>'} 【折抵券兌換】{'>'} 【輸入兌換碼】。 請先下載 iRent App，並申請審核通過成為 iRent 會員，方可使用 iRent 共享汽機車服務。（完成註冊程序需包含：建立帳號、上傳機車駕照並審核通過。）
                下載連結：<a href="https://irentxhims.page.link/NBrK" target="_blank" rel="noopener noreferrer">https://irentxhims.page.link/NBrK</a>
              </li>
              <li>折抵券兌換方式：開啟 iRent APP {'>'} 點選左側欄【☰】{'>'} 【優惠管理】{'>'} 【折抵券】{'>'} 【折抵券兌換】{'>'} 【輸入兌換碼】</li>
              <li>汽車折抵券可用於 iRent 共享汽車租金折抵。恕不得要求折換現金，亦不得將其轉讓予第三人</li>
              <li>折抵券不得與企業月結訂單併用，每張券限單次使用，若未使用完剩餘時數即失效</li>
              <li>使用本服務時，請於 iRent APP 上先行預約以便保留車輛，並須遵守 iRent 會員條款、用車相關規範、車輛租賃契約，及因個人行為導致信用積分不足無法繼續使用iRent共享汽機車租車服務，本公司得以保留車輛最終是否提供之權利</li>
              <li>倘若於租用車輛期間發生違規罰單或停車費，該筆費用必須由承租人自行負擔</li>
              <li>如對 iRent 折抵券有疑問請透過文字客服 (<a href="https://reurl.cc/zYbW6V" target="_blank" rel="noopener noreferrer">https://reurl.cc/zYbW6V</a>) 或透過 iRent APP {'>'} 點左上角【聯絡我們】與和雲客服聯絡</li>
            </ol>
          </div>
        </footer>
      );
    } else {
      // 2025 年版本 Footer (原本的)
      return (
        <footer className="footer-new">
          <div className="footer-content">
            <h3>注意事項</h3>
            <ol>
              <li>中獎內容不適用春節期間，優惠券使用期限為2025/2/5至2025/5/31</li>
              <li>抽獎後請自行保存中獎圖檔，抽獎人有盡善保管之義務，以免權益喪失</li>
              <li>本活動發放之獎項內容，無法折抵里程費、etag、罰款、逾時費用等其他費用</li>
              <li>所有經由本活動領取之獎項，皆須符合其票券規則方得以兌換與使用，用戶不得要求退款、折換現金及遞延使用</li>
              <li>如有任何疑問，請洽24小時服務專線（02）5589-0808</li>
              <li>和雲行動服務對本內容保有修改、終止、變更方案內容細節之權利</li>
              <li>和運租車之短期租車服務，由和雲行動服務提供</li>
            </ol>

            <h3>和運租車免費租車券、折價券</h3>
            <ol>
              <li>免費租車券限電話/臨櫃預約</li>
              <li>折價券可於和雲行動服務官網預約，於折價券號欄位輸入兌換序號進行折抵</li>
              <li>免費租車券、折價券僅適用於【一般租車專案】，不得使用於其他專案（如包月、票根優惠等等）</li>
              <li>每張券限單次使用，未使用完之餘額不得找零，且不適用於連續假期</li>
            </ol>

            <h3>iRent汽車折抵券</h3>
            <ol>
              <li>iRent折抵券序號請於iRent APP中「優惠券兌換」輸入、兌換並使用</li>
              <li>iRent折抵券不得與企業月結訂單併用，每張券限單次使用，若未使用完剩餘時數即失效</li>
              <li>每筆訂單限用一張，無法多張券合併使用</li>
            </ol>
          </div>
        </footer>
      );
    }
  };

  return (
    <>
      <section className="prize">
        <div className="prize-bg-color"></div>
        <div className="prize-bg1"></div>
        <div className="prize-bg2"></div>
        <div className="prize-card">
          <div className="prize-card-content">
            <div className="logo-container">
              <img className="logo-img" src={LogoImg} alt="和運租車" />
            </div>
            <div className="title-container">
              <img className="title-img" src={EventNameImg} alt="2026新春抽獎活動" />
            </div>
            <div className="subtitle-container">
              <img className="subtitle-img" src={SloganImg} alt="免費租車券、千元折價券等你拿！" />
            </div>
            
            {/* 顯示恭喜提示 */}
            {selectedCoupon && selectedCoupon.showCongrats && (
              <div className="subtext-container">
                <img className="subtext-img" src={CongratulationImg} alt="恭喜你！獲得" />
              </div>
            )}
            
            {/* 渲染 coupon */}
            {selectedCoupon && renderCoupon(selectedCoupon)}
            
            {/* 提示文字和序號 */}
            {selectedCoupon && selectedCoupon.code && (
              <div className="caution">
                <p className="caution-text">請自行截圖，保存圖檔，以免喪失權益！</p>
                <div className="serial-num-wrap">
                  <p className="caution-text">序號:</p>
                  <p className="caution-text serial-num">{selectedCoupon.code}</p>
                </div>
              </div>
            )}
          </div>
          
          {/* 燈籠裝飾 */}
          <div className="card-decoration1">
            <img className="card-decor-img" src={LanternA} alt="" />
          </div>
          <div className="card-decoration2">
            <img className="card-decor-img" src={LanternA} alt="" />
          </div>
          <div className="card-decoration3">
            <img className="card-decor-img" src={LanternB} alt="" />
          </div>
          <div className="card-decoration4">
            <img className="card-decor-img" src={LanternB} alt="" />
          </div>
        </div>
        <div className="prize-bg3"></div>
      </section>
      
      {/* Footer */}
      {renderFooter()}
    </>
  );
}

export default App;
